import { render, staticRenderFns } from "./shuoming.vue?vue&type=template&id=5ecd83e6&scoped=true"
import script from "./shuoming.vue?vue&type=script&lang=js"
export * from "./shuoming.vue?vue&type=script&lang=js"
import style0 from "./shuoming.vue?vue&type=style&index=0&id=5ecd83e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecd83e6",
  null
  
)

export default component.exports